var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgFormation = function SvgFormation(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_2",
    "data-name": "Calque 2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 156.14 171.1",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .formation-cls-1 {\n        stroke-width: 5px;\n      }\n\n      .formation-cls-1, .formation-cls-2, .formation-cls-3 {\n        fill: none;\n      }\n\n      .formation-cls-1, .formation-cls-3 {\n        stroke: #030f40;\n        stroke-linecap: round;\n        stroke-linejoin: round;\n      }\n\n      .formation-cls-4 {\n        clip-path: url(#clippath-2);\n      }\n\n      .formation-cls-5 {\n        clip-path: url(#clippath-6);\n      }\n\n      .formation-cls-2 {\n        stroke-width: 0px;\n      }\n\n      .formation-cls-6 {\n        clip-path: url(#clippath-7);\n      }\n\n      .formation-cls-7 {\n        clip-path: url(#clippath-1);\n      }\n\n      .formation-cls-8 {\n        clip-path: url(#clippath-4);\n      }\n\n      .formation-cls-9 {\n        clip-path: url(#clippath);\n      }\n\n      .formation-cls-10 {\n        clip-path: url(#clippath-3);\n      }\n\n      .formation-cls-3 {\n        stroke-width: 4.6px;\n      }\n\n      .formation-cls-11 {\n        clip-path: url(#clippath-5);\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("path", {
    className: "formation-cls-2",
    d: "M5.46,129.2v.33s-.02.01-.02.01c-.06,1.38-1.23,2.45-2.61,2.39-1.38-.06-2.45-1.23-2.39-2.61v-.33s5.01.21,5.01.21Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "formation-cls-2",
    d: "M46.82,128.59l.07.32h0c.28,1.36-.59,2.68-1.95,2.96-1.35.28-2.67-.59-2.95-1.95l-.07-.32,4.9-1.01Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "formation-cls-2",
    d: "M15.8,128.82l.03.3v.06c.15,1.37-.84,2.6-2.22,2.75-1.37.15-2.6-.85-2.75-2.22l-.04-.35,4.97-.55Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "formation-cls-2",
    d: "M36.35,124.26l.06.32c.26,1.36-.62,2.67-1.98,2.93-1.36.26-2.67-.62-2.93-1.98v-.03s-.07-.32-.07-.32l4.91-.93Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "formation-cls-2",
    d: "M56.04,143.7v.33c0,1.38-1.12,2.5-2.5,2.5s-2.5-1.12-2.5-2.5v-.33h5Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "formation-cls-2",
    d: "M90.63,152.12v.33c0,1.38-1.12,2.5-2.5,2.5s-2.5-1.12-2.5-2.5v-.33h5Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-6"
  }, /*#__PURE__*/React.createElement("path", {
    className: "formation-cls-2",
    d: "M133.15,142.29l.02.37c.07,1.38-1,2.55-2.37,2.61-1.37.07-2.54-.99-2.61-2.36v-.25s-.03-.28-.03-.28l5-.09Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-7"
  }, /*#__PURE__*/React.createElement("path", {
    className: "formation-cls-2",
    d: "M98.59,160.77v.33c0,1.38-1.12,2.5-2.5,2.5s-2.5-1.12-2.5-2.5v-.33h5Z"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image",
    width: 6,
    height: 12,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAYAAAAMCAYAAABBV8wuAAAACXBIWXMAAAsSAAALEgHS3X78AAAAFUlEQVQYlWNk5nf4z4AFMGETHNkSAJVaAWmmn2kxAAAAAElFTkSuQmCC"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Pictos"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "formation-cls-1",
    cx: 32.96,
    cy: 34.61,
    r: 9.27
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "formation-cls-9"
  }, /*#__PURE__*/React.createElement("image", {
    width: 6,
    height: 12,
    transform: "translate(-.17 127.71)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAYAAAAMCAYAAABBV8wuAAAACXBIWXMAAAsSAAALEgHS3X78AAAAKUlEQVQYlWNk5ndgZYAAZgYGhv9QNgsLAwPDXyjnPwMDwz8om5FhxAIAojQEXp2bWA4AAAAASUVORK5CYII="
  })), /*#__PURE__*/React.createElement("image", {
    width: 76,
    height: 85,
    transform: "translate(-.17 45.71)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEwAAABVCAYAAADjTgJ4AAAACXBIWXMAAAsSAAALEgHS3X78AAADpElEQVR4nO2cbXKbMBCGXyKaafOHXqU34BI9ZG/BCXqStBncpk1sY/oDrZFlgYUN2qXeZ4YRwYNZXu8XEhNAmUTGbQBhirLltmGMpq4ygEkwU5QH75CYH+4SeaoLBURaJYsK9r+I5LJIKFwp1CrCclYP4/Sopq6ypQtHU1fZbL/qDGJlVInmYE7xXLtuNvBaoZq6erj12iHmEGrsh7tJsKliLSWSteUmoWK9+2rBpoglVahrUsBVgsWKtaRQ1o7JYt2aJxfrw6SJNVdBmfwll7xLklBzVl1i0hfeu1jAjCEpRaylhCKib5Kzi5ciFjCThy3tXRHXT/YcGnWhMe/iDsWUYgERISl5iia1WMCEHBaC07s4xAJuFGxJpM7xjwrGmbvG4PIu4LKHtXZLisRQJGLbCvcGMu42gpPBGzdF2Qx8xJZbuL0LGPewE69a2pC1EBtax1zW1JVZzhy51ZEYEyyU8O86HIEBwUxR7pw/WSqlVIY8LCRQ29RVslcLpBLThykOQx4jqmGVkr+AgIeZonzzDmkOc4juw5q6elzamDUQEsz3qAzqYUdCSV9M7yWRKZ2+gvEqqQQ48TBTlH+4DFkLfki2zug+cD+lNEoymvQncrczp9fiCyZ2DVIKfpVsATTomlVqWMU8x0kgJJg7qlgeQ4IR+ljkcRTMFOULzsXRnObhJn3/obtFN8v6OZUxQ/NekhZG3JD01yENNBzPCAlm0IXiwe4rDq5glK8y9K2F4uF7WAZN9KOEPAzow1Lx8KskQflMRfNwPWzr7GeBzxWcetje2+CMyZDei7ke5IqjFXKAHABMUX6HChYFedgeXXi6vRiauvrCYZRkSLADzue+kuevNUCCvTvHSLQPiW1ZBVQl3cq4s/u74BmMSKiUJBhN7ezseABjSEp6vcmHQpIWcB/RiZZBQzIICUbhR9M6ygAkGOWGPfp5/G3wjDuHctgGwC+7bQH8hlDBuBM/CfYO4M2Or3bff3UzKVITvx+SbqV8D55x55BgL+gbVho/pTdHPiQYhZ/b5bOGpFSGVr6p21c8KOk/2+2H3f6ib2bZkDiZ6Hf6fh5TPHJTlF+hgkWToxPryY5HwZq6+sZmlWBydNVwj9MCwJ6/pJID+In+jUPYsWCzKBJTlC3Xv5LZoOvqa7u/sfsikPaIlKNb5X7GaWe/4TFHPjl6b3JnWT/ymCOfB3TTOP62iqTP0cDmTV292ovnOF12U9aMKcqWe/IQAP4Bn3ZhlCEw7QAAAAAASUVORK5CYII="
  }), /*#__PURE__*/React.createElement("g", {
    className: "formation-cls-7"
  }, /*#__PURE__*/React.createElement("image", {
    width: 9,
    height: 13,
    transform: "translate(40.83 127.71)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAkAAAANCAYAAAB7AEQGAAAACXBIWXMAAAsSAAALEgHS3X78AAAAPklEQVQYlWNkgAJmfof/DGjg78cDjAwMDAws2CTRARNMNV5FhBRQRxHMvcSbRMjx1HM43Bp8gUqUSSgAl2kAA7wOu8NJ6LsAAAAASUVORK5CYII="
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "formation-cls-4"
  }, /*#__PURE__*/React.createElement("image", {
    width: 8,
    height: 12,
    transform: "translate(9.83 127.71)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAMCAYAAABfnvydAAAACXBIWXMAAAsSAAALEgHS3X78AAAAM0lEQVQYlWNk5ncQYmBg+IuGef5+PPCOgYGBgYmBgeETAwT8YGBg+M3AwPAPSWwUUA0AAF5LDNnj3vXQAAAAAElFTkSuQmCC"
  })), /*#__PURE__*/React.createElement("image", {
    width: 27,
    height: 35,
    transform: "translate(9.83 95.71)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABsAAAAjCAYAAABl/XGVAAAACXBIWXMAAAsSAAALEgHS3X78AAACAElEQVRIicWWW5KVMBRFVwitVlkaB+AMnAST6eH0nPLtHPzUD6vUTj+8Dwj4kZy6McDt8LDcVRQQkqzsk8MBRaG0aU55m3f2del4AFUAOc70kzblnb3ZDIugqb4qbysBVldAh5cGJ0ClTdOthgED0Gf3I0i2QL8Ypk3zlNz22eNRCKfAxTCCC5+A5Dx4Z18l4xa5G8G0ae6zJhk8eGffAHhn6xxSoilnA9BFiOxTTxZO76zOxolLpU2Th34M06b5zsUJEdoDvXf27cyCi/ZrBOOyVx44x7aRK9GEu0WwU4SIu47g6sOSSQGmQlknD78QnClASpRO+2xV6qzj4kzkgfbaBN7Za4VhFiaZ10bwb8B7Zz+WTpYrD2UKOxHC13Jxc9WVqNRdFVfwmb9r35GCEC6VrOgMPAMH4CnCWu/sp62ANJQCE1fpZ2L0Zd4qgd3HwxGcuaWwkn2b6tASnB4nnm2SwH4CP+LxC3ggpP4ukn2bs35eA3splLU2zR1hj24I2VgBcxV+kyrgkZD24mQAnr2zt3vDaoKbjhA6FcHv9gZp0/Q1IYTpx+89If13V5VM/BivvxKycZVikqipo44QkjOs+JkpkezZIV7LL/RqZ3PyzqqaUJbkvNvEU+018I2QFKmbf/Ke1YRS5QlZKdq9LgqsjcDeO/sAoE2zW138b/oD5X3B5q3KvfMAAAAASUVORK5CYII="
  }), /*#__PURE__*/React.createElement("g", {
    className: "formation-cls-10"
  }, /*#__PURE__*/React.createElement("image", {
    width: 8,
    height: 13,
    transform: "translate(30.83 122.71)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAANCAYAAACUwi84AAAACXBIWXMAAAsSAAALEgHS3X78AAAAO0lEQVQYlWNgQAPM/A7/mfkd/sP4LMgcbIAJnyRlCmBWM/39eIBxgNwAA4zIDsKpAJ8iglaw4JKAeR8AmRoNX1vKlIMAAAAASUVORK5CYII="
  }))), /*#__PURE__*/React.createElement("line", {
    className: "formation-cls-1",
    x1: 61.82,
    y1: 63.05,
    x2: 87.81,
    y2: 32.46
  })), /*#__PURE__*/React.createElement("polyline", {
    className: "formation-cls-3",
    points: "153.85 64.81 79.93 64.81 79.93 2.3"
  }), /*#__PURE__*/React.createElement("line", {
    className: "formation-cls-3",
    x1: 79.93,
    y1: 73.44,
    x2: 153.85,
    y2: 73.44
  }), /*#__PURE__*/React.createElement("circle", {
    className: "formation-cls-1",
    cx: 70.85,
    cy: 99.92,
    r: 9.27
  }), /*#__PURE__*/React.createElement("circle", {
    className: "formation-cls-1",
    cx: 113.38,
    cy: 109.18,
    r: 9.27
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "formation-cls-8"
  }, /*#__PURE__*/React.createElement("image", {
    width: 6,
    height: 12,
    transform: "translate(50.83 142.71)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAYAAAAMCAYAAABBV8wuAAAACXBIWXMAAAsSAAALEgHS3X78AAAAH0lEQVQYlWNk5ndgZkAF/xkYGBgZ0AEzvwMThuCIAgDRJQGr/M504AAAAABJRU5ErkJggg=="
  })), /*#__PURE__*/React.createElement("image", {
    width: 40,
    height: 39,
    transform: "translate(50.83 113.71)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAnCAYAAAB9qAq4AAAACXBIWXMAAAsSAAALEgHS3X78AAACWElEQVRYhe2Xv44TMRCHv107ObgTskRJR0nHG+CK9+CJeBF6WkuUSDQ0V9FRhALJuoNwSZyjWE/W6/UGkeSyW9xPsux4vPanmfGfVBwhZexPoErKzhTrCqiCd5eHrlH9e0gPagHU8VupS4B5v8BePAigMvZ7BErhSoBiI7N1xgTv5icBVMZ+i+NkQp2Bpe3dZ8nv3N4ZG7yb7Vu/3mdUxl4DW5kr1ttY7mMZ0j6bqFLGbg4CVMZ+jU2ZQADThUsRSMNbZ+NyT8pag5DFECtjv9CGSUIryT2nzT8F1MG75wPzLBPoYojphluRqQeojP0cFxZAaetYz2mS/EUJakjK2BUF7+UMOWTHqIz9FEF0tEkCXwhg8O7l/4AVQNcDoDum4N0u9fIc3AIrYE2Ta6vYvwHWx8JBZ9cW4fKOHaAy9mMCtAbuErhN8O7VsXAJpC6ApZtGTo6eBzfAMtYhgobg3etTwSWQ6XU4qApAGfuBNuckBDNgFrx7c2q4VKm3cgXvanH1EnhK47kVrWcHPz6XBOQOuAFu4+8tsArevX1ogHTH5lLGbsWDm1hqGg8q4OAn0ilVKWPf072WauAqePfunCBDuahpwpu/TPY+Is4pTXv2Qf+eHF0a+EMLpWlfL5NQTfu2gybc9zTHziSkgd9Zn2JiOXib9T2hCfskVAOe5t6VsqB9PY8uDfyKBeAq1otxcPrKd60fC2RIGvgR28+S/psRWIqSEJPUk5Km761L+kfPaJKbJNVkjhiY0L079JqZzI0xpEfAY/UIeKzyf/hjqniiTN6Dkwf8C1mLm2zEIebKAAAAAElFTkSuQmCC"
  }), /*#__PURE__*/React.createElement("g", {
    className: "formation-cls-11"
  }, /*#__PURE__*/React.createElement("use", {
    transform: "translate(84.83 150.71)",
    xlinkHref: "#image"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "formation-cls-5"
  }, /*#__PURE__*/React.createElement("image", {
    width: 6,
    height: 12,
    transform: "translate(127.83 140.71)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAYAAAAMCAYAAABBV8wuAAAACXBIWXMAAAsSAAALEgHS3X78AAAAKklEQVQYlWNkgAJmfgc+BgaGfwwMDP8ZGBiYGaGCzFB5TgYGhu8MIxoAAPwdA7j+Kg5eAAAAAElFTkSuQmCC"
  })), /*#__PURE__*/React.createElement("image", {
    width: 41,
    height: 39,
    transform: "translate(92.83 122.71)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACkAAAAnCAYAAACSamGGAAAACXBIWXMAAAsSAAALEgHS3X78AAACHElEQVRYhe2XQW7UMBSGv4wLEhuy5QDsWLO3xKJXYMuaNYfoKdhyAiR2PgAX4ACVCppSmapNMxNPWNieeeO6jRqcoZXyS5aTN0ne59/PiadipFStLbARrU+O+yTmnDWvx+SqRsBdieQ90IlzlwDKeOw7Z82bSSBVrZtM8j2nuO1kOpAOWAFrYOOseVsEUtW6FUm5A1C6KN2U8F1o6xBbR2Bnzbv7GBYDgKswkNhyA1xkYlLSfSkn8nwdBalqvU6Sy7YQ8SHFa6KbDmjZudkBnar1l6EHpICxhsj0e1PtrHk5RKlq/SOBaoEmHN+wK4PGWfNhEDIASqgUtAd6Z82LIbjMs7/j67ALkBJwFQZy7az5OAQZCz8HiLPm+UPhMjm+RSD2V3yPd/naWfMpXr9Ibo7FLOHjcVUCEMBZcywA2wB5A1yG+N4i28IIwFTRwaMSgFKq1p/xjl7gDdsAv4FnQOusOYHbr4/cQqqmAAQIi+QinDbAMoC2Ip59BVVJP6lC7S3xU+3wTv7C1ygQIFWtN8m9W0BnjZqc1KsBzvF1CrBUtX4PA18cDufmCd7Jn8AVcIaHtQD31pqzZmgQJXUW+kvgVP4wyYIYqdPkPG5OqDL1uNWBnUTV+lUufqeThwYManPBxzTdILZv7DYxjwvSWfMnF/8fU/pgzZClNEOW0gxZSjNkKc2QpTRDltIMWUpPAvKIA/1t/Rc9CSf/Aj7QA0mpPSRtAAAAAElFTkSuQmCC"
  }), /*#__PURE__*/React.createElement("g", {
    className: "formation-cls-6"
  }, /*#__PURE__*/React.createElement("use", {
    transform: "translate(92.83 159.71)",
    xlinkHref: "#image"
  }))))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgFormation);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/formation.3d87d3b01a807b826056a79760f5ca96.svg";